import { render } from "./BookingInfo.vue?vue&type=template&id=35e477cc&scoped=true"
import script from "./BookingInfo.vue?vue&type=script&lang=js"
export * from "./BookingInfo.vue?vue&type=script&lang=js"

import "./BookingInfo.vue?vue&type=style&index=0&id=35e477cc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35e477cc"

export default script